module.exports = __webpack_public_path__ + "static/media/footer.92a29f2f.jpg";